import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let policyListMachine: any;

export const useSMPolicyList = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  policyListMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(policyListMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    policyListMachine,
    policyListState: state,
    policyListSend: send,
  };
};
